import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { EditorInputField } from '../../../editor-container/editor-model';
import { IframeCommunicationService } from '../../../services/iframe-communication.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export interface FontFamily{
  name:string,
  value:string
}

@Component({
  selector: 'kve-font-input',
  templateUrl: './font-input.component.html',
  styleUrls: ['./font-input.component.scss']
})
export class FontInputComponent implements OnInit,OnChanges {
  @Input()field:EditorInputField;
  fieldName:string;

  fontFamilies$:Subscription;
  primaryFontFamily:string;
  secondaryFontFamily:string;
  destroy$ = new Subject<void>();

  primarySelected:FontFamily;
  secondarySelected:FontFamily;

  fontFamilies:FontFamily[] = [
    {
      name:"Arial",
      value:"Arial, sans-serif"
    },
    {
      name:"Courier New",
      value:"Courier New, monospace"
    },
    {
      name:"Georgia",
      value:"Georgia, serif"
    },
    {
      name:"Lato",
      value:"Lato, sans-serif"
    },
    {
      name:"Lobster",
      value:"Lobster, sans-serif"
    },
    {
      name:"Merriweather",
      value:"Merriweather, sans-serif"
    },
    {
      name:"Montserrat",
      value:"Montserrat, sans-serif"
    },
    {
      name:"Open Sans",
      value:"Open Sans, sans-serif"
    },
    {
      name:"Oswald",
      value:"Oswald, sans-serif"
    },
    {
      name:"PT Sans",
      value:"PT Sans, sans-serif"
    },
    {
      name:"Playfair Display",
      value:"Playfair Display,serif"
    },
    {
      name:"Raleway",
      value:"Raleway, sans-serif"
    },
    {
      name:"Roboto",
      value:"Robotto, sans-serif"
    },
    {
      name:"Roboto Condensed",
      value:"Roboto Condensed, sans-serif"
    },
    {
      name:"Roboto Slab",
      value:"Roboto Slab, sans-serif"
    },
    {
      name:"Source Sans 3",
      value:"Source Sans 3, sans-serif"
    },
    {
      name:"Ubuntu",
      value:"Ubuntu, sans-serif"
    }
  ]

  constructor(private communicator: IframeCommunicationService) { }

  ngOnInit(): void {
    this.fontFamilies$ = this.communicator.receive('fontFamilies').pipe(takeUntil(this.destroy$))
    .subscribe((payload:any) => {
      console.log(payload)
      this.primaryFontFamily = payload.data.options.primaryFontFam;
      this.secondaryFontFamily = payload.data.options.secondaryFontFam
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes["field"]){
      console.log(this.field)
      this.fieldName = this.field.name
    }
  }
  onMouseOver(e){
   if(e.type == "primary"){
    this.primaryFontFamily = e.font
   }else{
    this.secondaryFontFamily = e.font
   }

  }
  //primaryFontFam:styles.getPropertyValue('--font-family-primary'),
  //secondaryFontFam:styles.getPropertyValue('--font-family-secondary')
  onFontSelect(selection:any){
    console.log(selection);
    if(selection.type == "primary"){
      this.communicator.sendFromParent({id:"primaryFont",value:selection.value})
    }else{
      this.communicator.sendFromParent({id:"secondaryFont",value:selection.value})
    }
  }

}


